﻿import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import definitions from '../../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';

class Feedback extends React.Component {
    constructor(props) {
        super(props);

        if (this.props.showDelay > 0) {
            this.delay = this.props.showDelay;
            this.state = {
                visible: false
            }
        } else {
            this.state = {
                visible: true
            }
        }
    }

    static get propTypes() {
        return {
            condition: PropTypes.func.isRequired,
            showDelay: PropTypes.number,
            heading: PropTypes.string,
        }
    }

    componentDidUpdate() {
        if (!this.state.visible) {
            setTimeout(() => this.setState({ visible: true }), this.delay);
        } else if(!this.props.condition()) {
            this.state.visible = false ;
        }
    }

    render() {
        return this.state.visible && this.props.condition() ? (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                <FeedbackWrapper>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                    >
                        {this.props.heading && (<h2>
                            {this.props.heading}
                        </h2>)}
                        {this.props.children}
                    </motion.div>
                </FeedbackWrapper>
            </motion.div>
        ) : null;
    }
}

const FeedbackWrapper = styled.div`
    position: relative;
    width: 752px;
    max-width: 100%;
    height: auto;

    margin: 0 auto;
    margin-top: 30px;

    padding: 30px;
    font-size: 16px;

    background: ${definitions.colors.grayBackground};
    border: 1px solid ${definitions.colors.grayBorder};

    h2 {
        color: black;
        font-size: 28px;
        margin-bottom: 10px;
    }

    img {
        height: 110px;
        width: auto;

        margin-top: 20px;
        margin-bottom: 20px;
    }

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        width: 0;
        height: 0;
        border: 16px solid transparent;
        border-bottom-color: ${definitions.colors.grayBorder};

        border-top: 0;
        margin-left: -16px;
        margin-top: -16px;
        background-color: transparent;
    }

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        width: 0;
        height: 0;
        border: 15px solid transparent;
        border-bottom-color: ${definitions.colors.grayBackground};
        border-top: 0;
        margin-left: -15px;
        margin-top: -15px;
        background-color: transparent;
    }
`;
export const FeedbackSection = styled.div`
    text-align: left;
    padding-left: 30px;
    position: relative;

    &:not(:last-child) {
        border-bottom: 1px solid ${definitions.colors.grayBorder};
        padding-bottom: 20px;
        margin-bottom: 20px;
    }

    h3 {
        font-size: 20px;
        font-weight: normal;

        &:before {
            content: ' ';
            width: 20px;
            height: 20px;
            background-image: url('/images/tip.svg');
            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;
            position: absolute;
            top: -2px;
            left: 0;
        }
    }
`;

export default Feedback;
